"use strict";
// packages/contracts/src/tipo-material.ts — Fase 03, Plano 08 (CAD-04).
// Contratos para categorias técnicas de Tipo de Material (taxonomia de 27 valores).
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=tipo-material.js.map